import React from 'react'
import PropTypes from 'prop-types'

export const DataGridRowRounded = ({ children }) => {
  return <b className="rowRoundedCell">{children}</b>
}

DataGridRowRounded.propTypes = {
  children: PropTypes.node.isRequired
}
